import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';
import { usePlanFeatureGate } from '../../feature-gates/use-plan-feature-gate';
import { Features } from '../../constants/features';

export const usePickToToteFeatureEnabled = () => {
  const flagEnabled = useFeatureFlag(FeatureFlagDeclarations.enablePickToTote);
  const pickToToteFeature = usePlanFeatureGate(Features.WarehouseMobileTotePicking);
  const sellerFeatureEnabled = pickToToteFeature?.isFeatureEnabled;

  return flagEnabled || sellerFeatureEnabled;
};
